import React, { useEffect, useState } from 'react';
import { HOME_STATS, DAILY_SESSIONS, MASTER_CLASSES, MEMBERSHIP_PLANS } from '../data/appData';
import { openWhatsAppMessage } from '../utils/contact';

function MiniContentCard({ title, badge, duration }) {
  return (
    <div className="mini-card">
      <span className="chip chip-accent">{badge}</span>
      <h3 className="mini-title">{title}</h3>
      <p className="mini-text">{duration}</p>
    </div>
  );
}

function MembershipSummary({ plans, onSelectPlan }) {
  return (
    <div className="membership-summary">
      <h2 className="section-title">Planes Sportivos</h2>
      <div className="membership-grid">
        {plans.map((plan) => (
          <article key={plan.id} className="membership-card">
            <header>
              <h3>{plan.name}</h3>
              <span className="membership-price">{plan.price}</span>
            </header>
            <ul>
              {plan.perks.map((perk) => (
                <li key={perk}>{perk}</li>
              ))}
            </ul>
            <button type="button" className="pill-button pill-button-outline" onClick={() => onSelectPlan(plan.id)}>
              Ver detalle
            </button>
          </article>
        ))}
      </div>
    </div>
  );
}


function HomeView({ profile, onNavigateToPlan = () => { }, onNavigateToWorkout = () => { } }) {
  const [selectedPlanId, setSelectedPlanId] = useState(null);

  useEffect(() => {
    if (typeof document === 'undefined') return undefined;
    if (selectedPlanId) document.body.classList.add('modal-open');
    else document.body.classList.remove('modal-open');
    return () => document.body.classList.remove('modal-open');
  }, [selectedPlanId]);

  const openPlanDetail = (planId) => {
    const fallbackPlan = MEMBERSHIP_PLANS[0]?.id || null;
    setSelectedPlanId(planId || fallbackPlan);
  };

  const closePlanDetail = () => setSelectedPlanId(null);
  const activePlan = selectedPlanId ? MEMBERSHIP_PLANS.find((plan) => plan.id === selectedPlanId) : null;

  // New Quick Actions Handlers (Mock)
  const handleQuickAction = (action) => {
    // Could route to specific tabs/modals
    if (action === 'agenda') onNavigateToPlan();
    else if (action === 'start_workout' || action === 'routine') onNavigateToWorkout();
    else alert(`Acción rápida: ${action}`);
  };

  const formatWhatsAppMessage = (plan) => {
    // ... (Existing logic kept simple or moved)
    return `Hola, me interesa el plan ${plan.name}`;
  };

  const handleStartPlan = () => {
    if (!activePlan) return;
    openWhatsAppMessage(formatWhatsAppMessage(activePlan));
    closePlanDetail();
  };


  return (
    <div className="screen">
      {/* Plan Detail Modal (Keep existing logic) */}
      {activePlan && (
        <div className="plan-detail-modal" style={{ zIndex: 2000 }}>
          <div className="plan-detail-card">
            <button className="plan-detail-close" onClick={closePlanDetail}>×</button>
            <h2>{activePlan.name}</h2>
            <p>{activePlan.price}</p>
            <button className="pill-button pill-button-primary" onClick={handleStartPlan}>Inscribirme</button>
          </div>
        </div>
      )}

      {/* 1. Hero Glass 2.0 */}
      <section className="section hero-section">
        <div className="hero-glass">
          <div className="hero-glass-content">
            <p className="eyebrow" style={{ color: '#a5f3fc' }}>HOLA, {profile?.name?.toUpperCase() || 'JAVIER'}</p>
            <h1 className="hero-glass-title">Hoy toca Pecho + Tríceps</h1>
            <p style={{ color: 'rgba(255,255,255,0.7)', fontSize: '0.9rem', marginBottom: '1.5rem' }}>
              Tu racha está en fuego 🔥. No rompas la cadena.
            </p>
            <button className="pill-button pill-button-primary" onClick={() => handleQuickAction('start_workout')}>
              ⚡ Iniciar Rutina
            </button>
          </div>
        </div>
      </section>

      {/* 2. Quick Actions Grid */}
      <section className="section">
        <div className="quick-actions-grid">
          <div className="quick-action-btn" onClick={() => handleQuickAction('agenda')}>
            <span className="quick-action-icon">📅</span>
            <span className="quick-action-label">Reservar</span>
          </div>
          <div className="quick-action-btn" onClick={() => handleQuickAction('qr')}>
            <span className="quick-action-icon">🎟️</span>
            <span className="quick-action-label">Acceso</span>
          </div>
          <div className="quick-action-btn" onClick={() => handleQuickAction('routine')}>
            <span className="quick-action-icon">💪</span>
            <span className="quick-action-label">Rutina</span>
          </div>
          <div className="quick-action-btn" onClick={() => handleQuickAction('staff')}>
            <span className="quick-action-icon">💬</span>
            <span className="quick-action-label">Staff</span>
          </div>
        </div>
      </section>

      {/* 3. Stats (Already redesigned to 3 items) */}
      <section className="section">
        <div className="stat-grid">
          {HOME_STATS.map(({ id, icon, label, value, suffix }) => (
            <div key={id} className="stat-card">
              <span className="stat-icon">{icon}</span>
              <div>
                <p className="stat-label">{label}</p>
                <p className="stat-value">{value}{suffix && <span className="stat-suffix">{suffix}</span>}</p>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* 4. Glass Sessions */}
      <section className="section">
        <header className="section-header">
          <h2 className="section-title">Próximas Clases</h2>
          <button className="link-button" onClick={onNavigateToPlan}>Ver todo</button>
        </header>
        <div className="horizontal-list">
          {DAILY_SESSIONS.map((session) => (
            <div key={session.id} className="session-card-glass">
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <span style={{ fontSize: '1.5rem' }}>{session.icon}</span>
                <span className={`badge badge-outline`}>{session.time}</span>
              </div>
              <h3>{session.title}</h3>
              <div className="session-glass-meta">
                <span>📍 {session.location}</span>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Challenge Banner (Simplified) */}
      <section className="section">
        <div className="card challenge-card" style={{ background: 'linear-gradient(45deg, #1e1e2f, #2d2d44)' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <div>
              <span className="chip chip-accent">Desafío Invierno</span>
              <h3 style={{ margin: '0.5rem 0', color: 'white' }}>12 sesiones · 30 días</h3>
              <span style={{ fontSize: '0.8rem', color: '#aaa' }}>5 completadas</span>
            </div>
            <div style={{ width: '60px', height: '60px', borderRadius: '50%', border: '4px solid #38bdf8', display: 'grid', placeItems: 'center', fontWeight: 'bold' }}>
              42%
            </div>
          </div>
        </div>
      </section>

    </div>
  );
}

export default HomeView;
